import { mediaQueries, size, colors } from '@everlywell/leaves';
import styled from 'styled-components';

const colorMap = {
  Primary: colors.white,
  Secondary: colors.teal1,
  Tertiary: colors.gray1,
};

// 48px of total vertical spacing between sections on mobile, 80px on desktop
export const SectionWrapper = styled.section<{
  backgroundColor?: 'Primary' | 'Secondary' | 'Tertiary';
  removePadding?: boolean;
}>`
  position: relative;
  padding: ${({ removePadding }) => (removePadding ? '' : `${size.lg}px 0`)};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? colorMap[backgroundColor] : ''};

  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 1440px;
    margin: 0 auto;
    padding: ${size.xl2}px 0;
  }
`;
